$(function () {

    if (isRealName()) {
        var cardLen = loadValue('cardLen', false);
        var type = getParamsByName("type");
        var typeId;

        if (!isNull(cardLen) && Number(cardLen) > 0) {
            getList();
            setTimeout(function () {
                if (type == '0') {
                    typeId = $('#t3').children().length > 0 ? document.getElementById('fundProductList') : document.getElementById('agencyFundTitle');
                } else if (type == '1') {
                    typeId = document.getElementById('combinedProductList');
                } else if (type == '2') {
                    typeId = document.getElementById('stgFundList');
                } else if (type == '3') {
                    typeId = $('#t2_spfund').children().length > 0 ? document.getElementById('spFundList_title') : document.getElementById('agencyGdDiv');
                } else if (type == '4') {
                    typeId = $('#ylProductTable').children().length > 0 ? document.getElementById('ylFundTitle') : document.getElementById('agencyYlFundTitle');
                }
                if (typeId) {
                    typeId.scrollIntoView()
                }
            }, 700);
        } else {
            setUnBindCardInfo('绑卡立享收益', '立即绑卡', 'isHaveBankCard(\'wallet/mybindbankcard.html\',\'添加银行卡，立即享受收益！\',\'立即添加\',\'暂不\')');
        }
    } else {
        // 未实名的，查询是否做过持仓认证，做过持仓认证的可以看到代销资产
        toApi_toAcCg("S15Q409", {},
            function (res) {
                if (isNull(res.custna) && isNull(res.idtfno)) {
                    gotoFirstbindcard();
                } else {
                    getList();
                }

            }, "login", "",
            function (data) {
                gotoFirstbindcard();
            });
    }
});

function getList() {

    $('#list').html('');

    // 通过[基金持仓分页列表]接口获取用户持仓明细
    //   var params = {
    //     playFlg: 1,
    //   }
    //   toApi_toAc("S091544", params, function (data) {
    //     var personalFundCode = getPersonalFundCode();
    //     if (!isNull(personalFundCode)) {
    //         console.log("S15Q427=>",data);
    //         setHoldPosition(data);
    //     } else {
    //         toApi("qrywalletfundcode.tml", function(data) {
    //             localStorage.personalFundCode = data.personalFundCode;
    //             setHoldPosition(data);
    //         });
    //     }
    //   },function(err){
    //     if(err.respCode == '100000'){
    //         window.location.href = phURL + "login.html";
    //     }
    //   });
    var params = { "channelCode": null, agencyNo: '' };
    toApi_toAcCg("S15Q427", params, function (data) {
        var personalFundCode = getPersonalFundCode();
        if (!isNull(personalFundCode)) {
            console.log("S15Q427=>", data);
            setHoldPosition(data);
        } else {
            toApi("qrywalletfundcode.tml", function (data) {
                localStorage.personalFundCode = data.personalFundCode;
                setHoldPosition(data);
            });
        }
    }, function (err) {
        if (err.respCode == '100000') {
            window.location.href = phURL + "login.html";
        }
    });
}

function handleFundRate(fundRate) {
    var rateAndColor = {};
    if (!isNull(fundRate)) {
        fundRate = toThousands(fundRate, 2)
        if (fundRate > 0) {
            fundRate = '+' + fundRate;
            rateAndColor.color = 'red';
        } else if (fundRate < 0) {
            rateAndColor.color = 'green';
        } else {
            rateAndColor.color = 'cello';
        }
    } else {
        fundRate = '-';
        rateAndColor.color = 'cello';
    }
    rateAndColor.rate = fundRate;
    return rateAndColor;
}

function setHoldPosition(data) {
    var personalFundCode = getPersonalFundCode();
    var list1 = []; //钱包
    var fund_list = []; // 基金资产
    var list4 = []; //货币Plus
    var list7 = []; // 稳收宝
    var stg_list = []; //投顾资产
    var comFund_list = []; // 组合资产
    var spFund_list = []; //高端理财
    // if (data.fundList.length === 0) {
    //     setUnBindCardInfo('暂无持仓数据', '立即充值', 'isHaveBankCard(\'wallet/recharge.html\',\'添加银行卡，立即享受收益！\',\'立即添加\',\'暂不\')');
    //     return;
    // }
    //钱包
    if (data.wallet && Object.keys(data.wallet).length) {
        data.wallet.availableAmount = toThousands(data.wallet.availableAmount);
        var wallet_dayProfitAmount = numberFormatter(data.wallet.dayProfitAmount, 2);
        data.wallet.dayProfitAmount = wallet_dayProfitAmount.value;
        data.wallet.yestodayProcolor = wallet_dayProfitAmount.color;
        var wallet_profitAmountTotal = numberFormatter(data.wallet.profitAmountTotal, 2);
        data.wallet.profitAmountTotal = wallet_profitAmountTotal.value;
        data.wallet.totlamcolor = wallet_profitAmountTotal.color;
        list1.push(data.wallet);
        if (list1.length > 0) {
            var htmlList = template('tpl_row', {
                "list": list1
            });
            $('#t1').html(htmlList);
        }
    } else {

        $('#walletBox').addClass('none');
    }
    //基金资产
    $('#haveCard').removeClass('none');
    if (data.fundList && data.fundList.length) {
        // 基金
        var fundList = []; // 直销
        var agencyFundList = []; // 代销
        data.fundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    detail.fundType = item.fundType;
                    if (detail.isAplusAsset == '1') {
                        if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                            fundList.push(detail)
                        } else if (detail.mainFlag == '0') {
                            fundList.push(detail)
                        }
                    } else {
                        agencyFundList.push(detail);
                    }
                })
            } else {
                fundList.push(item);
            }
        })
        fundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = isNull(dayIncome) ? '--' : numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';

            fund.productName = fund.productName ? fund.productName : fund.fundName;
            if (fund.portfolioType && fund.portfolioType == "TP") {
                fund.productCode = "目标盈";
            } else if (fund.portfolioType && fund.portfolioType == "TY") {
                fund.productCode = "止盈";
            } else if (fund.portfolioType && fund.portfolioType == "IP") {
                fund.productCode = "智能定投";
            } else {
                fund.productCode = fund.productCode ? fund.productCode : fund.fundCode;
            }
        })
        if (fundList.length > 0) {
            console.log("fundList", fundList);
            $('#fundProductList').removeClass('none');
            var htmlList = template('fundList', {
                "list": fundList
            });
            $('#t3').html(htmlList);
        }

        // 代销
        agencyFundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';
        })
        if (agencyFundList.length > 0) {
            $('#agencyFundTitle').removeClass("none");
            var htmlList = template('agencyProduct', {
                "list": agencyFundList
            });
            $('#agencyProductTable').html(htmlList);
        }
    }

    // 养老基金
    if (data.ylFundList && data.ylFundList.length) {
        var ylFundList = []; // 直销
        var agencyYlFundList = []; // 代销
        data.ylFundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    if (detail.isAplusAsset == '1') {
                        if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                            ylFundList.push(detail)
                        } else if (detail.mainFlag == '0') {
                            ylFundList.push(detail)
                        }
                    } else {
                        agencyYlFundList.push(detail);
                    }
                })
            } else {
                ylFundList.push(item);
            }
        })
        ylFundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';
        })
        if (ylFundList.length > 0) {
            $('#ylFundTitle').removeClass("none");
            var htmlList = template('ylProduct', {
                "list": ylFundList
            });
            $('#ylProductTable').html(htmlList);
        } else {
            // $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#ylFundTitle').addClass("none");
            $('#ylFundTable').addClass("none");
        }

        // 养老代销
        agencyYlFundList.forEach(function (fund) {
            fund.formatAvailableAmount = toThousands(fund.availableAmount);
            var dayIncome;
            if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
                dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.00;
            }
            fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
            fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
            var income = fund.fundType == '04' ? fund.profitAmountTotal : fund.holdProfitAmount;
            fund.formatIncome = numberFormatter(income).value;
            fund.formatIncomeColor = numberFormatter(income).color;
            fund.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === fund.profitCalculateDate ? '今日' : '昨日';
        })
        if (agencyYlFundList.length > 0) {
            $('#agencyYlFundTitle').removeClass("none");
            var htmlList = template('agencyYlProduct', {
                "list": agencyYlFundList
            });
            $('#agencyYlProductTable').html(htmlList);
        } else {
            // $('#productTable').html('<td colspan="5"><div class="hold-box h-min"><p class="no-data">暂无数据</p></div></td>');
            $('#agencyYlFundTitle').addClass("none");
            $('#agencyYlFundTable').addClass("none");
        }
    }


    //投顾资产
    if (data.stgFundList && data.stgFundList.length) {
        data.stgFundList.forEach(function (e) {
            var rateAndColor2 = numberFormatter(e.dayProfitAmount, 2);
            e.dayProfitAmount = rateAndColor2.value;
            e.yestodayProcolor = rateAndColor2.color;

            e.availableAmount = toThousands(e.availableAmount); //资产市值

            var totlam_profitAmountTotal = numberFormatter(e.profitAmountTotal, 2);
            e.profitAmountTotal = totlam_profitAmountTotal.value; //累计收益
            e.totlamcolor = totlam_profitAmountTotal.color;
            stg_list.push(e);
        })
        if (stg_list.length > 0) {
            console.log("stgList", stg_list);
            $('#stgFundList').removeClass('none');
            var htmlList = template('stgList', {
                "list": stg_list
            });
            $('#stg_list').html(htmlList);
        }
    }
    //组合资产
    if (data.combFundList && data.combFundList.length) {
        data.combFundList.forEach(function (e) {
            e.availableAmount = toThousands(e.availableAmount);
            var yestoday_dayProfitAmount = numberFormatter(e.dayProfitAmount, 2);
            e.dayProfitAmount = yestoday_dayProfitAmount.value;
            e.yestodayProcolor = yestoday_dayProfitAmount.color;
            var totlam_profitAmountTotal = numberFormatter(e.profitAmountTotal, 2);
            e.profitAmountTotal = totlam_profitAmountTotal.value;
            e.totlamcolor = totlam_profitAmountTotal.color;

            e.fundType = 'combined';

            comFund_list.push(e);
        });
        if (comFund_list.length > 0) {
            console.log("comFund_list", comFund_list)
            $('#combinedProductList').removeClass('none');
            var htmlList = template('combinedProduct', {
                "list": comFund_list
            });
            $("#t5").html(htmlList);
        }
    }
    //高端理财
    if (data.spFundList && data.spFundList.length) {
        // 专户资产
        var spFundList = []; // 直销
        var agencySpFundList = []; // 代销
        data.spFundList.forEach(function (item) {
            if (item.detailList && item.detailList.length > 0) {
                item.detailList.forEach(function (detail) {
                    if (detail.isAplusAsset == '1') {
                        if (detail.mainFlag == '1' && Number(detail.availableAmount) > 0) {
                            spFundList.push(detail)
                        } else if (detail.mainFlag == '0') {
                            spFundList.push(detail)
                        }
                    } else {
                        agencySpFundList.push(detail);
                    }
                })
            } else {
                spFundList.push(item);
            }
        })
        // 直销专户
        spFundList.forEach(function (sp) {
            sp.formatAvailableAmount = toThousands(sp.availableAmount);
            var daySPIncome;
            if (sp.dayIncomeMap && Object.keys(sp.dayIncomeMap).length > 0) {
                daySPIncome = sp.dayIncomeMap[sp.profitCalculateDate] || 0.00;
            }
            sp.formatDayProfitAmount = numberFormatter(daySPIncome).value;
            sp.formatDayProfitAmountColor = numberFormatter(daySPIncome).color;
            sp.formatProfitAmountTotal = numberFormatter(sp.profitAmountTotal).value;
            sp.formatProfitAmountTotalColor = numberFormatter(sp.profitAmountTotal).color;
            sp.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === sp.profitCalculateDate ? '今日' : '昨日';
            toApi_toAcCg('S15Q087', { fundCode: sp.fundCode }, function (spData) {
                sp.buyFlag = spData.isBuy;
                sp.risklevel = spData.fundRiskLevelCode;
            })
        })
        console.log(spFundList);
        setTimeout(function () {
            if (spFundList.length > 0) {
                console.log("spFund_list", spFundList);
                $('#spFundList_title').removeClass('none');
                var htmlList = template('spFundList', {
                    "list": spFundList
                });
                $('#t2_spfund').html(htmlList);
            }
        }, 300)

        // 代销专户
        agencySpFundList.forEach(function (sp) {
            sp.formatAvailableAmount = toThousands(sp.availableAmount);
            var daySPIncome;
            if (sp.dayIncomeMap && Object.keys(sp.dayIncomeMap).length > 0) {
                daySPIncome = sp.dayIncomeMap[sp.profitCalculateDate] || 0.00;
            }
            sp.formatDayProfitAmount = numberFormatter(daySPIncome).value;
            sp.formatDayProfitAmountColor = numberFormatter(daySPIncome).color;
            sp.formatProfitAmountTotal = numberFormatter(sp.profitAmountTotal).value;
            sp.formatProfitAmountTotalColor = numberFormatter(sp.profitAmountTotal).color;
            sp.profitDateText = new Date().toLocaleDateString().replace('/', '').replace('/', '') === sp.profitCalculateDate ? '今日' : '昨日';
            toApi_toAcCg('S15Q087', { fundCode: sp.fundCode }, function (spData) {
                sp.buyFlag = spData.isBuy;
                sp.risklevel = spData.fundRiskLevelCode;
            })
        })
        console.log(agencySpFundList);
        setTimeout(function () {
            if (agencySpFundList.length > 0) {
                $('#agencyGdDiv').removeClass("none");
                var htmlList = template('agencyPro', {
                    "list": agencySpFundList
                });
                $('#agencyProTable').html(htmlList);
            } else {
                $('#agencyGdDiv').addClass("none");
                $('#agencyGdTable').addClass("none");
            }
        }, 300)
    }

    // var params = {
    //     playFlg: 0,
    //     financedType:"02"
    // };
    // // 通过[基金持仓分页列表]接口获取用户持仓明细
    // toApi_toAc("S091544", params, function (data1) { // 货币plus
    //     data1.funds.forEach(function(e) {
    //         var rateAndColor = numberFormatter(e.positionIncome, 2);
    //         var rateAndColor2 = numberFormatter(e.yestodayPro, 2);
    //         e.assertMarketValue = toThousands(e.assertMarketValue);
    //         e.totlam = rateAndColor.value;
    //         e.totlamcolor = rateAndColor.color;
    //         e.yestodayPro = rateAndColor2.value;
    //         e.yestodayProcolor = rateAndColor2.color;
    //         var yieldAndColor = numberFormatter(e.totalIncomeYield, 2);
    //         e.totalIncomeYield = yieldAndColor.value + '%';
    //         e.totalIncomeYieldColor = yieldAndColor.color;
    //         list4.push(e);
    //     });

    //     if (list4.length > 0) {
    //         $('#hbPlusList').removeClass('none');
    //         var htmlList = template('hbproduct', {
    //             "list": list4
    //         });
    //         $('#t4').html(htmlList);
    //     }
    // });
    // /**
    //  * 稳收宝
    //  */
    // var params1 = {
    //     playFlg:0,
    //     financeType:"08"
    // };
    // toApi_toAc("S15Q084", params1, function (data1) { // 稳收宝
    //     var e = {};
    //     var walamt_wenShou = data1.avalableShare;
    //     var yesrevTitle_wenShou = data1.dayIncomeTitle;

    //     var totalr_wenShou = numberFormatter(data1.sumPortfolioPositionIncome, 2);
    //     var yesrev_wenShou = numberFormatter(data1.dayIncome, 2);

    //     e.assertMarketValue = toThousands(walamt_wenShou);
    //     e.totlam  = totalr_wenShou.value;
    //     e.totlamcolor = totalr_wenShou.color;
    //     e.yestodayPro = yesrev_wenShou.value;
    //     e.yestodayProcolor = yesrev_wenShou.color;
    //     e.prodna = "钱包稳收宝";
    //     e.fundCode = data1.fundCode;
    //     e.yesrevTitle_wenShou = yesrevTitle_wenShou;
    //     list7.push(e);

    //     if (Number(walamt_wenShou )> 0) {
    //         $('#wenShouList').removeClass('none');
    //         var htmlList = template('wenShouProduct', {
    //             "list": list7
    //         });
    //         $('#t7').html(htmlList);
    //     }
    // });

    //组合子账户持仓
    // combinedProductLsit();
    // 目标盈持仓
    // getTPList();
}

function combinedProductLsit() {
    toApi_toAc('S091503', {}, function (data) {
        var list = [];
        data.portfolioAcctWithHoldingList.forEach(function (e) {
            e.assetMarketValue = toThousands(e.assetMarketValueWithoutOnWay);

            var yestodayProObj = numberFormatter(e.yesterdayIncome, 2);
            e.yestodayPro = yestodayProObj.value;
            e.yestodayProcolor = yestodayProObj.color;

            var totlamObj = numberFormatter(e.positionIncome, 2);
            e.totlam = totlamObj.value;
            e.totlamcolor = totlamObj.color;

            e.fundType = 'combined';

            list.push(e);
        });
        if (data.portfolioAcctWithHoldingList.length > 0) {
            $('#combinedProductList').removeClass('none');
            var htmlList = template('combinedProduct', {
                "list": list
            });
            $("#t5").html(htmlList);
        }
    })
}

function getTPList() {
    toApi_toAc('S091610', {
        portfolioType: 'TP'
    }, function (data) {
        var TP_list = [];
        data.portfolioAcctWithHoldingList.forEach(function (e) {
            e.assetMarketValueWithoutOnWay = toThousands(e.assetMarketValueWithoutOnWay);

            var yestodayProObj = numberFormatter(e.yesterdayIncome, 2);
            e.yesterdayIncome = yestodayProObj.value;
            e.yestodayProcolor = yestodayProObj.color;

            var totlamObj = numberFormatter(e.positionIncome, 2);
            e.positionIncome = totlamObj.value;
            e.totlamcolor = totlamObj.color;

            e.fundType = 'TP';

            TP_list.push(e);
        });
        if (data.portfolioAcctWithHoldingList.length > 0) {
            console.log("TPList", data.portfolioAcctWithHoldingList)
            $('#TPList').removeClass('none');
            var htmlList = template('TProduct', {
                "list": TP_list
            });
            $("#t6_TP").html(htmlList);
        }
    })
}

function gotoFundTransfor(prodna, fundcode, beforeAvailableShare, afterAvailableShare, sharetype, holdShare, availableShare, limitExflag) {
    if (limitExflag !== '0' && limitExflag !== '2') {
        window.location.href = window.phURL + 'fund/fundTrading.html?prodna=' + prodna + '&fundcode=' + fundcode + '&beforeAvailableShare=' + beforeAvailableShare + '&afterAvailableShare=' + afterAvailableShare + '&sharetype=' + sharetype + '&holdShare=' + holdShare + '&availableShare= ' + availableShare + '&limitExflag=' + limitExflag;
    } else {
        alert('该基金不可转换');
    }
}

function gotoNextPage(pageId, profitCalculateDate, fundCode, shareType, fundType, isPortfolioAsset, productCode, agencyNo, isAplusAsset, channelCode, transAcctIdSub, portfolioType, portfolioCode, isChannle) {
    console.log(fundType)
    if (isPortfolioAsset == '1') {
        alertIknowMsg('该产品的持仓详情需在A加钱包APP进行查询，微信版服务正在努力开发中~~');
        return;
    } else if (productCode == "目标盈" || productCode == "止盈" || productCode == "智能定投") {
        combinedTip('本产品需通过A加钱包APP进行查看');
    } else {
        if (isChannle == 'isYangLao') {
            localStorage.whereComeFromMyFund = 'account/position.html';
            window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&shareType=' + shareType + '&fundType=' + fundType + '&agencyNo=' + agencyNo + '&isAplusAsset=' + isAplusAsset + '&channelCode=' + channelCode + '&transAcctIdSub=' + transAcctIdSub + '&profitCalculateDate=' + profitCalculateDate + '&portfolioType=' + portfolioType + '&portfolioCode=' + portfolioCode + '&isChannle=' + isChannle;
        } else if (isChannle == 'isDaiXiaoTrue') {
            localStorage.whereComeFromMyFund = 'account/position.html';
            window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&shareType=' + shareType + '&fundType=' + fundType + '&agencyNo=' + agencyNo + '&isAplusAsset=' + isAplusAsset + '&channelCode=' + channelCode + '&transAcctIdSub=' + transAcctIdSub + '&profitCalculateDate=' + profitCalculateDate + '&portfolioType=' + portfolioType + '&portfolioCode=' + portfolioCode + '&isChannle=' + isChannle;
        } else {
            localStorage.whereComeFromMyFund = 'account/position.html';
            window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&shareType=' + shareType + '&fundType=' + fundType + '&agencyNo=' + agencyNo + '&isAplusAsset=' + isAplusAsset + '&channelCode=' + channelCode + '&transAcctIdSub=' + transAcctIdSub + '&profitCalculateDate=' + profitCalculateDate + '&portfolioType=' + portfolioType + '&portfolioCode=' + portfolioCode + '&isChannle=' + '';
        }
    }
}

function goDetail(pageId, fundCode, fundType, isPortfolioAsset, productCode) {
    //组合详情
    if (isPortfolioAsset == '1') {
        alertIknowMsg('该产品的持仓详情需在A加钱包APP进行查询，微信版服务正在努力开发中~~');
        return;
    } else if (productCode == "目标盈" || productCode == "止盈" || productCode == "智能定投" ) {
        combinedTip('本产品需通过A加钱包APP进行查看');
    } else {
        window.location.href = window.phURL + pageId + '?fundCode=' + fundCode + '&fundType=' + fundType;
    }
}

function gotoFundBuy() {
    // {
    //     fundCode: outLineFundCode,
    //     productInfoId: loadValue("summaryID", false),
    //     transCode: outLineUrl == "addfundinvestment" ? "039" : "020", // 认申购020，定投039，转换036
    //     ptfCode: 0
    // }
    if (!loadValue("unScrollbottom", false)) {
        alert("请先完成全文阅读");
        return;
    }
    removeValue("unScrollbottom", false);
    $("#pupFundOutline").hide();
    var outLineFundCode = loadValue("outLineFundCode", false);
    var outLineUrl = loadValue("outLineUrl", false);
    var outLineFundName = loadValue("outLineFundName", false);
    removeValue("outLineFundCode", false);
    removeValue("outLineUrl", false);
    var S092019params = {
        fundSummaryVos: fundSummaryArr,
        source: 'position'
    };
    var nextPage = function () {
        removeValue("summaryID", false);
        if (outLineUrl == "addfundinvestment") {
            window.location.href = phURL + 'fund/addfundinvestment.html?fundName=' + outLineFundName + '&fundCode=' + outLineFundCode;
        } else {
            window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
        }
    };
    toApi_toAc("S092019", S092019params, nextPage, '', '', nextPage);
}

function readNext(){
    console.log(222222,itemArr)
    //循环对象，找到下一个未读的展示，如果找不到，则代表全部已读，执行之后的业务逻辑
    noReadArr= itemArr.filter(function(val){
        return val.hasRead == false
    })
    console.log(33333,noReadArr)
    if(noReadArr.length==0){
        $("#pupFundOutline").hide();
        var outLineFundCode = loadValue("outLineFundCode", false);
        var outLineUrl = loadValue("outLineUrl", false);
        var outLineFundName = loadValue("outLineFundName", false);
        removeValue("outLineFundCode", false);
        removeValue("outLineUrl", false);
        var S092019params = {
            fundSummaryVos: fundSummaryArr,
            source: 'position'
        };
        var nextPage = function () {
            removeValue("summaryID", false);
            if (outLineUrl == "addfundinvestment") {
                window.location.href = phURL + 'fund/addfundinvestment.html?fundName=' + outLineFundName + '&fundCode=' + outLineFundCode;
            } else {
                window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
            }
        };
        toApi_toAc("S092019", S092019params, nextPage, '', '', nextPage);

    }else{
        // nowIndex = noReadArr[0].eq;
        console.log(nowIndex);
    
        if (itemArr[nowIndex].hasRead) {
          if (parseInt(nowIndex) + 1 == itemArr.length) {
            nowIndex = 0;
          } else {
            nowIndex++;
          }
          $(".outLine_box").eq(nowIndex).show().siblings().hide();
          $(".titleItem")
            .eq(nowIndex)
            .addClass("active")
            .siblings()
            .removeClass("active");
          return;
        }
        itemArr[nowIndex].hasRead = true;
    
        hasReadNum = itemArr.filter(function (val) {
          return val.hasRead == true;
        }).length;
        if (parseInt(hasReadNum) < itemArr.length) {
          $(".nextBtn2").text(
            "我已阅读并知悉(" + hasReadNum + "/" + itemArr.length + ")"
          );
        } else {
            readNext();
        }
    
        if (parseInt(nowIndex) + 1 == itemArr.length) {
          nowIndex = 0;
        } else {
          nowIndex++;
        }
        $(".outLine_box").eq(nowIndex).show().siblings().hide();
          $(".titleItem")
            .eq(nowIndex)
            .addClass("active")
            .siblings()
            .removeClass("active");
      }
}

//获取基金状态state
function getFundState(type, fundCode, availableShare, totalShare) {
    console.log(availableShare);
    // availableShare 为isDaiXiaoTrue 的时候，是代销高端理财产品，跳转区别用
    // return;
    var params = {
        fundCode: fundCode,
        typeId: "440",
        year: String(new Date().getFullYear())
    };
    toApi_toAcCg("S15Q087", params, function (data) {
        var personalFundCode = getPersonalFundCode();
        if (!isNull(personalFundCode)) {
            console.log("S15Q087=>", data);
            runShowTask(type, data, availableShare, totalShare);
        } else {
            toApi("qrywalletfundcode.tml", function (data) {
                localStorage.personalFundCode = data.personalFundCode;
                runShowTask(type, data, availableShare, totalShare);
            });
        }
    }, function (err) {
        if (err.respCode == '100000') {
            window.location.href = phURL + "login.html";
        }
    });
}
// 根据基金状态执行 各类产品点击事件操作
function runShowTask(type, result, availableShare, totalShare) {
    switch (type) {
        case 'fund_buy': // 基金资产 "买入" 按钮控制
            return fundBuy(result.fundCode, result.onShelf, result.fundState, "0", result.fundSubType, result.fundType);
        case 'fund_sellOut': //基金资产 和 高端理财 "卖出" 按钮控制
            return sale(result.fundCode, availableShare, result.fundState, result.fundSubType, result.openDateStart, result.openDateEnd, result.nowTime, '0');
        case 'fund_change': // 基金资产 "转换" 按钮控制
            if (result.limitExflag == '0' && result.limitExflag == '2') {
                alert('该基金暂不可转换');
                return;
            }
            return fundTransfer(result.limitExflag, result.fundState, result.fundName, result.fundCode, availableShare, totalShare, result.shareType, availableShare, 1, '0', result.fundSubType);
        case 'fund_targetLaunch': // 基金资产 "定投" 按钮控制
            return goFundInvestment(result.sertype, result.fundCode, result.fundName, '0', result.fundSubType, result.fundType);
        case 'spfund_details': // 高端理财 "详情" 按钮控制
            return gotoSpecialProductPosition(result.fundCode, result.shareType, result.fundState, 'account/position.html', availableShare);
        default:
            break;
    }
}

// 点击买入按钮
function gotoBuy(fundCode) {
    if (fundCode == '000905') {
        window.location.href = window.phURL + 'wallet/recharge.html';
        return;
    }
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (value) {
        fundBuy(fundCode, value.onShelf, value.fundState, '0', value.fundSubType, value.fundType);
    })
}

// 点击卖出按钮
function gotoSale(fundCode) {
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (data) {
        sale(fundCode, data.shareType, data.fundState, data.fundSubType, data.openDateStart, data.openDateEnd, data.nowTime, data.isPortfolioAsset)
    })
}

// 点击转换按钮
function gotoTransfer(fundCode, availableShare) {
    toApi_toAcCg('S15Q032', { fundCode: fundCode }, function (value) {
        var beforeAvailableShare;
        var afterAvailableShare;
        value.shareType == '0' ? beforeAvailableShare = availableShare : afterAvailableShare = availableShare;

        fundTransfer(value.limitExflag, value.fundState, value.fundName, value.fundCode, beforeAvailableShare, afterAvailableShare, value.shareType, availableShare, 1, value.isPortfolioAsset)
    })
}